import React from 'react'
import { Button, Drawer, Flex } from 'antd'
import { IHistoryPurchase } from '../../../../api/history/historyApi'

interface Props {
  show: boolean
  inforHistoryPurchase?: IHistoryPurchase
  onClose: () => void
}

const OrderHistoryDrawer: React.FC<Props> = ({
  show, inforHistoryPurchase,

  onClose

}) => {
  return (
    <Drawer
      open={show}
      title='Chi tiết lịch sử mua hàng'
      className='rs-drawer'
      closeIcon={false}
      footer={
        <Button
          block
          onClick={onClose}
        >Đóng</Button>
      }
      onClose={onClose}
    >
      <Flex vertical className='gap-18px'>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Số hóa đơn</span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.invoiceNumber}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Mã SR/ĐL</span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.srCode}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Họ & tên </span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.userUser}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Số lượng </span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.quantity}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Số lượng DKDV </span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.quantityDKDV}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Hình thức TT </span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.paymentMethod}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Số khung </span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.chassisNumber}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Số KM hiện tại</span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.currentKM}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Ngày GDTD</span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.gtdtDate}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Ngày ĐNHS</span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.dnshDate}</span>
        </Flex>
        <Flex justify='space-between' className='gap-8px'>
          <span className="neutral-gray-700">Ngày xuất</span>
          <span className="neutral-gray-400 text-end">{inforHistoryPurchase?.exportDate}</span>
        </Flex>
      </Flex>
    </Drawer>
  )
}

export default OrderHistoryDrawer
